import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Salaire / paie — symbole € dans une pastille duotone */
export const EuroIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille menthe */}
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      {/* Cercle bleu */}
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Symbole € */}
      <path
        d="M15.5 8.5a4.5 4.5 0 0 0-6.5 4 4.5 4.5 0 0 0 6.5 4M7 11.25h6M7 13.25h5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
EuroIcon.displayName = "EuroIcon";
